import { registerEntityEndpoint as e } from "@editor/ui-utils";
var t = e("api-teaser"), { getEntity: n, listEntities: r } = t, i = async (e) => n(e);
//#endregion
export { i as n, t };

//# sourceMappingURL=api-teaser.service-_FM23jXz.js.map